export default __webpack_public_path__ + "static/media/token_value_accrual.216a7cec.png";